/**
 * @typedef {object} LeaderboardState
 * @property {NavState} nav
 */

/**
 * @typedef {object} NavState
 * @property {number|null} round
 * @property {string} club
 * @property {string} filter
 */
